// LoginModal.js
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./LoginModal.css";
import ForgotPasswordModal from "../ForgotPasswordModal/ForgotPasswordModal";
import "toastr/build/toastr.min.css";
// import toastr from "toastr";
// import axios from "axios";
import { GetUserDetails, isValidEmail } from "../../Helpers/Utility";
import { postData } from "../../Services/Api";
import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export default function LoginModal({
  show,
  handleClose,
  handleSignUp,
  showLoginModal,
}) {
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("redirect_uri")) {
      const user = GetUserDetails();
      // if (user?.token) {
      //   try {
      //     axios.get(
      //       `${searchParams.get("redirect_uri")}?token=${user.token}&email=${
      //         user.email
      //       }&id=${user.id}&name=${user.name}`
      //     );
      //   } catch (err) {}
      //   window.close();
      // } else {
      showLoginModal();
      // }
    }
  }, []);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (formData.email.trim() === "") {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Email and password did not match";
    }

    if (formData.password.trim() === "") {
      newErrors.password = "Password is required";
    }
    // else if (formData.password.length < 6 || !hasSpecialCharacter(formData.password)) {
    //   newErrors.password =
    //     'Password must be at least 6 characters long and include at least one special character';
    // }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const data = {
        email: formData.email,
        password: formData.password,
      };
      const postDataResponse = await postData("auth/login", data);
      if (postDataResponse.success) {
        setMessage(postDataResponse.message);
        toast.success("Login successfull!");
        setFormData({ email: "", password: "" });
        const loginDetails = {
          id: postDataResponse.data.user.id,
          email: postDataResponse.data.user.email,
          name: postDataResponse.data.user.name,
          // isAdmin: postDataResponse.data.user.is_admin === 1 ? true : false,
          isAdmin: postDataResponse.data.user.role_id != 3 ? true : false,
          roleId: postDataResponse.data.user.role_id,
          token: postDataResponse.data.token,
        };
        if (postDataResponse.data.user.role_id == 2) {
          loginDetails.adminId = postDataResponse.data.admin_id;
        }
        if (searchParams.get("redirect_uri")) {
          axios.get(
            `${searchParams.get("redirect_uri")}/callback?token=${
              loginDetails.token
            }&email=${loginDetails.email}&id=${loginDetails.id}&name=${
              loginDetails.name
            }`
          );
          window.close();
          return;
        }
        localStorage.setItem("loginDetails", JSON.stringify(loginDetails));
        if (loginDetails?.roleId == 1) {
          // Redirect to dashboard if the user is an admin
          window.location.href = "/dashboard";
        } else if (loginDetails?.roleId == 2) {
          // Redirect to chat if the user is an employee
          window.location.href = "/dashboard/chat";
        } else {
          // Reload the page for non-admin users
          window.location.reload(true);
        }
        handleClose();
      } else {
        setMessage(postDataResponse.message);
        toast.error(postDataResponse.message);
      }
    } catch (error) {
      console.error("Error posting data:", error);
      setMessage("Error posting data. Please try again later.");
      console.log(message);
      toast.error("login failed");
    }
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const response = await axios.post(
  //       "https://korkhondi.com/api/v1/subscriber/auth/login",
  //       { email, password },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         withCredentials: false // Add this line to exclude cookies
  //       }
  //     );

  //     if (response.status === 200) {
  //       // Handle successful login here, e.g., redirect or display success message
  //       console.log("Login successful");
  //       toastr.success("Login successful");
  //     } else {
  //       // Handle login failure, e.g., display error message
  //       console.error("Login failed");
  //       toastr.error("Login failed");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  const handleForgotPasswordClose = () => {
    setShowForgotPassword(false);
  };
  const handleForgotPasswordShow = () => {
    // Close the login modal
    handleClose();
    // Show the forgot password modal
    setShowForgotPassword(true);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="">
      <Modal
        className="shadow-lg"
        show={show}
        onHide={handleClose}
        centered
        size="xl"
      >
        <div className="position-absolute start-0 top-0 p-5 z-n1 greenOval rounded-circle"></div>
        <div className="container-fluid shadow-lg">
          <div className="row no-gutter">
            <div className="col-md-6 bg-white rounded-start-5">
              <div className="login   py-5">
                <div className="card border-0 w-100 px-2 ps0 pe0">
                  <div className="card-title text-center ">
                    <h3 className="p-3 pb-1">LOGIN</h3>
                    <small className="text-secondary">
                      {/* How to i get started lorem ipsum dolor at? */}
                    </small>
                  </div>
                  <div className="card-body ps0 pe0">
                    <form>
                      <div className="mb-4">
                        <label htmlFor="username" className="form-label">
                          Email*
                        </label>
                        <input
                          type="text"
                          className="form-control customFormText px-3 py-2 rounded-5"
                          placeholder="Email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="text-danger">{errors.email}</div>
                        )}
                      </div>
                      <div className="mb-4 position-relative">
                        <label htmlFor="password" className="form-label">
                          Password*
                        </label>
                        <span
                          className="position-absolute top-50 bottom-100 end-0 me-3 translate-middle-y cursor-pointer"
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? <LuEyeOff /> : <LuEye />}
                        </span>
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control customFormText px-3 py-2 rounded-5 pl-5" // Adjusted padding for input field
                          id="password"
                          placeholder="Password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        {errors.password && (
                          <div className="text-danger">{errors.password}</div>
                        )}
                      </div>

                      <div className="mb-4 d-flex align-items-center">
                        <input
                          type="checkbox"
                          className="mb-0 form-check-input customFormText mx-2"
                          id="remember"
                        />
                        <label htmlFor="remember" className="mb-0 form-label">
                          Remember Me
                        </label>
                        <div
                          className="d-flex justify-content-end ms-auto text-primary cursor-pointer"
                          onClick={handleForgotPasswordShow}
                        >
                          Forgot password ?
                        </div>
                      </div>
                      <div className="d-grid">
                        <Button
                          className="btn btn-default startedBtn rounded-5 pt-2 pb-2 fs-5 px-4"
                          onClick={handleSubmit}
                        >
                          Login Now
                        </Button>
                        <div className="d-flex justify-content-center py-4 ">
                          <span className="text-black text-center mx-2">
                            You don’t have an account?
                          </span>
                          <span
                            className="text-primary cursor-pointer"
                            onClick={handleSignUp}
                          >
                            Sign Up
                          </span>{" "}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 rounded-end-2 d-none d-md-flex bg-image"></div>
          </div>
        </div>
        <div className="position-absolute p-5 bottom-0 end-0 z-n1 redOval rounded-circle"></div>
      </Modal>
      <ForgotPasswordModal
        show={showForgotPassword}
        handleClose={handleForgotPasswordClose}
      />
    </div>
  );
}
